import styles from "../styles/toggle.module.sass";

export default function ImagineToggle({label, setItem}) {
  return (
    <div className={styles.toggleContainer}>
        <div className={styles.toggleLabel}>{label}</div>
      <label className={styles.switch}>
        <input
          type="checkbox"
          onChange={(e) => {
            console.log(e.target.checked);
            setItem(e.target.checked);
          }}
        />
        <span className={styles.slider}></span>
      </label>
    </div>
  );
}
